<template>
  <panel-noticias />
</template>

<script>
import panelNoticias from "@/components/dashboard/PanelNoticias.vue";

export default {
  name: "VistaEditorNoticias",
  components: {
    panelNoticias,
  },
};
</script>
